import { ChangeDetectorRef, Component } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiFragment } from '../../../entities/api-fragment.entity';
import { BaseColumnComponent } from '../../../services/base-column-component';

@Component({
    standalone: false,
    selector: 'digihaven-count-cell',
    templateUrl: './count-cell.component.html'
})
export class CountCellComponent extends BaseColumnComponent<ApiFragment> {
    value$!: Observable<number | string>;

    constructor(protected cd: ChangeDetectorRef) {
        super(cd);

        this.value$ = combineLatest([this.data$, this.fieldDefinition$, this.defaultValue$]).pipe(
            map(([fragment, fieldDef, defaultValue]) => {
                const field = fragment.getField(fieldDef.DottedKey);
                return Array.isArray(field) ? field.length : defaultValue;
            })
        );
    }
}
